import { render } from "./app.vue?vue&type=template&id=53f13272"
import script from "./app.vue?vue&type=script&setup=true&lang=js"
export * from "./app.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/www/vhosts/pqv3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/views/app.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53f13272"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53f13272', __exports__)) {
    console.log('reload')
    api.reload('53f13272', __exports__)
  }
  
  module.hot.accept("./app.vue?vue&type=template&id=53f13272", () => {
    console.log('re-render')
    api.rerender('53f13272', render)
  })

}


export default __exports__